import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FeatureFlagsService {
    private loadedConfig: any;

    public set(config: {}) {
        this.loadedConfig = config;
    }

    public get(feature: string): any {
        return this.loadedConfig[feature];
    }
}
